export const APP_SUPPORTED_LOCALES = ['id', 'en'] as const

export type AppLocale = (typeof APP_SUPPORTED_LOCALES)[number]

const envLocale = process.env.REACT_APP_DEFAULT_LOCALE

export const DEFAULT_APP_LOCALE: AppLocale =
  envLocale === 'en' ? 'en' : 'id'

export function isAppLocale(value: string): value is AppLocale {
  return APP_SUPPORTED_LOCALES.includes(value as AppLocale)
}
